import { render } from "./AuditCommView.vue?vue&type=template&id=50f17043&scoped=true"
import script from "./AuditCommView.vue?vue&type=script&lang=js"
export * from "./AuditCommView.vue?vue&type=script&lang=js"

import "./AuditCommView.vue?vue&type=style&index=0&id=50f17043&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f17043"]])

export default __exports__